webpackJsonp([73783555933647],{

/***/ 1651:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AppointmentGroup","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"appointments","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"Appointment","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-appointment-group-f02646d9eb0510072e04.js